module.exports = __webpack_public_path__ + "img/10.916fec5c.png";